import React from 'react';
import { usePagination, DOTS } from './usePagination';
const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  let previous_classnames = 'pagination-item'
  if (currentPage === 1) previous_classnames += ' disabled';
  let next_classnames = 'pagination-item'
  if (currentPage === lastPage) next_classnames += ' disabled';

  return (
    <ul
      className={`pagination-container ${className}`}
    >
      <li
        className={previous_classnames}
        onClick={onPrevious}
      >
        <div className="arrow left" />
      </li>
      {paginationRange.map(pageNumber => {
        if (pageNumber === DOTS) {
          return <li className="pagination-item dots">&#8230;</li>;
        }
        let item_classnames = 'pagination-item';
        if (pageNumber === currentPage) item_classnames += " selected";

        return (
          <li
            key={pageNumber}
            className={item_classnames}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={next_classnames}
        onClick={onNext}
      >
        <div className="arrow right" />
      </li>
    </ul>
  );
};

export default Pagination;
